<template>
  <b-container fluid>
    <b-row>
      <b-col md="4" offset-md="4" cols="10" offset="1" v-if="showDataForm">
        <h4 class="text-center mt-4 p-2">
          <span class="mark-bottom">編輯個人資料</span>
        </h4>
        <b-form @submit.prevent="onSubmit" @reset="onReset">
          <b-form-group id="username-field" label="帳號" label-for="username" description="不可更改">
            <b-form-input id="username" v-model="form.username" type="email" disabled></b-form-input>
          </b-form-group>
          <b-form-group id="name-field" label="姓名" label-for="name" :invalid-feedback="nameInvalidFeedback" :state="nameState">
            <b-form-input id="name" v-model="form.name" :state="nameState" :disabled="busy"></b-form-input>
          </b-form-group>
          <b-form-group id="school_num-field" label="學號" label-for="school_num" :invalid-feedback="schoolNumInvalidFeedback" :state="schoolNumState">
            <b-form-input id="school_num" v-model="form.school_num" :disabled="busy" :state="schoolNumState"></b-form-input>
          </b-form-group>
          <b-form-group id="tel-field" label="電話" label-for="tel" description="請填入可以聯絡的資訊" :invalid-feedback="telInvalidFeedback" :state="telState">
            <b-form-input id="tel" v-model="form.tel" :disabled="busy" :state="telState"></b-form-input>
          </b-form-group>
          <b-form-group id="email-field" label="Email" label-for="email" description="請填入可以聯絡的資訊" :invalid-feedback="emailInvalidFeedback" :state="emailState">
            <b-form-input id="email" v-model="form.email" :disabled="busy"  :state="emailState"></b-form-input>
          </b-form-group>
          <label>密碼：</label>
          <b-link href="#" @click="currShow='reset-form'">設定新密碼</b-link>
          <hr>
          <b-button type="submit" class="float-right btn-pur-dark" :disabled="busy">
            <b-spinner v-if="busy" small label="Spinning"></b-spinner>
            <span v-else>送出</span>
          </b-button>
        </b-form>
      </b-col>
      <b-col md="4" offset-md="4" cols="10" offset="1" v-if="showResetPwdForm">
        <b-form @submit.prevent="onSubmitReset" @reset="onReset">
          <!--b-form-group
            id="old_pwd-field"
            label="舊密碼"
            label-for="old_pwd"
            description="現在的密碼"
          >
            <b-form-input
              id="old_pwd"
              v-model="pwdForm.old_pwd"
              type="password"
            ></b-form-input>
          </b-form-group-->
          <b-form-group id="new_pwd-field" label="新密碼" label-for="new_pwd" :invalid-feedback="passwordInvalidFeedback" :state="passwordState">
            <b-form-input id="new_pwd" v-model="pwdForm.new_pwd" type="password" :state="passwordState" ></b-form-input>
          </b-form-group>
          <b-form-group id="new_repwd-field" label="重新輸入新密碼" label-for="new_repwd" description="再一次輸入密碼" :invalid-feedback="repasswordInvalidFeedback" :state="repasswordState">
            <b-form-input id="new_repwd" v-model="pwdForm.new_repwd" type="password" :state="repasswordState" ></b-form-input>
          </b-form-group>
          <b-link href="#" @click="currShow='data-form'">返回</b-link>
          <hr>
          <b-button type="submit" variant="primary" class="float-right" :disabled="busy">
            <b-spinner v-if="busy" small label="Spinning"></b-spinner>
            <span v-else>送出</span>
          </b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { State } from '../library/EventBus.js'
import { EmailRegExp } from '../library/Var.js'
export default {
  data () {
    return {
      currShow: 'data-form',
      form: {},
      pwdForm: {
        old_pwd: '',
        new_pwd: '',
        new_repwd: ''
      },
      busy: false
    }
  },
  computed: {
    user () {
      return State.user
    },
    showDataForm () {
      return this.currShow === 'data-form'
    },
    showResetPwdForm () {
      return this.currShow === 'reset-form'
    },
    nameInvalidFeedback () {
      if (this.form.name.length >= 2) {
        return ''
      } else if (this.form.name.length < 2) {
        return '姓名至少需要2位'
      } else {
        return '請輸入姓名'
      }
    },
    nameState () {
      return this.form.name.length >= 2
    },
    telInvalidFeedback () {
      return '請填入電話'
    },
    telState () {
      return this.form.tel.length > 0
    },
    emailInvalidFeedback () {
      if (EmailRegExp.test(this.form.email)) {
        return ''
      } else {
        return '信箱不符合格式'
      }
    },
    emailState () {
      return EmailRegExp.test(this.form.email)
    },
    schoolNumInvalidFeedback () {
      return '請填入學號'
    },
    schoolNumState () {
      return this.form.school_num.length > 0
    },
    passwordInvalidFeedback () {
      if (this.pwdForm.new_pwd.length >= 6) {
        return ''
      } else if (this.pwdForm.new_pwd.length > 0) {
        return '密碼至少需要6位'
      } else {
        return '請填入密碼'
      }
    },
    passwordState () {
      return this.pwdForm.new_pwd.length >= 6
    },
    repasswordInvalidFeedback () {
      if (!this.passwordState || this.pwdForm.new_pwd === this.pwdForm.new_repwd) {
        return ''
      } else {
        return '與密碼不同'
      }
    },
    repasswordState () {
      if (!this.passwordState) return undefined
      return this.pwdForm.new_pwd === this.pwdForm.new_repwd
    }
  },
  methods: {
    onReset () {
      const { username, name, school_num, tel, email } = this.user
      this.$set(this, 'form', { username, name, school_num, tel, email })
      this.$set(this, 'pwdForm', {old_pwd: '', new_pwd: '', new_repwd: ''})
    },
    async onSubmit () {
      if (this.busy) return
      this.busy = true
      try {
        await this.$api.putPersonal(this.form)
        this.$bus.$emit('update:user')
        setTimeout(() => {
          this.busy = false
          this.showToast(true)
          this.onReset()
        }, 1000)
      } catch (err) {
        this.busy = false
        this.showToast(false)
      }
    },
    async onSubmitReset () {
      if (this.busy) return
      this.busy = true
      const { new_pwd: password } = this.pwdForm
      try {
        await this.$api.putPersonalPwd({ password })
        setTimeout(() => {
          this.busy = false
          this.showToast(true)
          this.onReset()
        }, 1000)
      } catch (err) {
        this.busy = false
        this.showToast(false)
      }
    },
    markChanged (name) {
      this.$set(this.changed, name, true)
    },
    showToast (success) {
      if (success) {
        this.$bvToast.toast('您的資料已更新。', {
          title: '更新成功',
          variant: 'success'
        })
      } else {
        this.$bvToast.toast('連線異常，請嘗試多次，若仍發生請聯絡管理員。', {
          title: '更新失敗',
          variant: 'warning'
        })
      }
    }
  },
  created () {
    this.onReset()
  },
  watch: {
    currShow () {
      this.onReset()
    },
    user () {
      this.onReset()
    }
  }
}
</script>
